import { Component } from "react";
import "./UserDetailsNotAllowed.css";

const ADMINS_EMAIL = "scheduling@talaera.com";

export default class UserDetailsNotAllowed extends Component {
  render() {
    return (
      <div className="user-details-not-allowed">
        <p>Sorry, you’re not allowed to see this page.</p>
        <p>
          If you believe this is incorrect, please contact&nbsp;
          <a className="btn" href={"mailto:" + ADMINS_EMAIL}>
            {ADMINS_EMAIL}
          </a>
        </p>
      </div>
    );
  }
}
